/**
 * Viewport box as the `bbox` query value for viewport-bounded map layers,
 * rounded OUTWARD to a 0.01° grid (~1 km) so small pans reuse one query key.
 *
 * Outward, never to nearest: when zoomed in, the view is narrower than one
 * grid step, and rounding both edges to nearest can collapse the box to a
 * line. The server then filters every shape out, and the layer seemed to
 * vanish on zoom. Floor the west/south edge, ceil the east/north edge, so
 * the box can only grow.
 */
export function outwardBbox(b: [number, number, number, number]): string {
  const [w, s, e, n] = b;
  const down = (v: number) => (Math.floor(v * 100) / 100).toFixed(2);
  const up = (v: number) => (Math.ceil(v * 100) / 100).toFixed(2);
  return [down(w), down(s), up(e), up(n)].join(',');
}
